import { FunctionComponent, ReactNode, useContext } from 'react'
import styled, { css } from 'styled-components'
import contextSportsHeader, {
  SportsHeaderContextType,
} from '@contexts/sportsHeader'
import { computeTeaserWidth } from '@widgets/Teaser/utils'
import { ViewportTypeValues } from '@contexts/viewport'
import { desktopCSS, tabletCSS, mobileCSS } from '@measures/responsive'

type StyledStatusTitleProps = Pick<
  SportsHeaderContextType,
  'teaserFlex' | 'teaserType' | 'isInMegaModule'
>

const { SportsHeaderContext } = contextSportsHeader

const StyledStatusTitle = styled.div<StyledStatusTitleProps>`
  ${({
    theme: {
      fonts: { sourceSansPro },
      colors: {
        white,
        grey: { grey_100 },
      },
    },
    teaserFlex,
    teaserType,
    isInMegaModule,
  }) => {
    let fontSizeDesktop
    let heightDesktop
    const desktopTeaserFlex = teaserFlex['desktop']
    const teaserWidthDesktop = computeTeaserWidth({
      flexValue: desktopTeaserFlex,
      viewportType: ViewportTypeValues.DESKTOP,
    })

    let fontSizeTablet
    let heightTablet
    const tabletTeaserFlex = teaserFlex['tablet']
    const teaserWidthTablet = computeTeaserWidth({
      flexValue: tabletTeaserFlex,
      viewportType: ViewportTypeValues.TABLET,
    })

    let fontSizeMobile
    let heightMobile

    if (
      teaserType === 'listitem' ||
      (teaserType === 'standard' && isInMegaModule)
    ) {
      fontSizeDesktop = '9px'
      heightDesktop = '10px'
      fontSizeTablet = '9px'
      heightTablet = '10px'
    } else {
      if (desktopTeaserFlex === '6') {
        fontSizeDesktop = `${0.0119 * teaserWidthDesktop}px`
        heightDesktop = `${0.01389 * teaserWidthDesktop}px`
      } else if (desktopTeaserFlex === '4') {
        fontSizeDesktop = `${0.01807 * teaserWidthDesktop}px`
        heightDesktop = `${0.02108 * teaserWidthDesktop}px`
      } else if (desktopTeaserFlex === '3') {
        fontSizeDesktop = `${0.02032 * teaserWidthDesktop}px`
        heightDesktop = `${0.02235 * teaserWidthDesktop}px`
      } else if (desktopTeaserFlex === '2') {
        fontSizeDesktop = `${0.03125 * teaserWidthDesktop}px`
        heightDesktop = `${0.034375 * teaserWidthDesktop}px`
      }

      if (tabletTeaserFlex === '6') {
        fontSizeTablet = `${0.01807 * teaserWidthTablet}px`
        heightTablet = `${0.02108 * teaserWidthTablet}px`
      } else if (tabletTeaserFlex === '3') {
        fontSizeTablet = `${0.02032 * teaserWidthTablet}px`
        heightTablet = `${0.02235 * teaserWidthTablet}px`
      }
    }

    if (['standard', 'listitem'].includes(teaserType)) {
      fontSizeMobile = '9px'
      heightMobile = '10px'
    } else {
      fontSizeMobile = '2.667vw'
      heightMobile = '2.9334vw'
    }

    return css`
      white-space: nowrap;
      font-family: ${sourceSansPro};
      font-weight: normal;
      line-height: 1;
      color: ${white};
      background-color: ${grey_100};
      padding: 0 4px;
      display: flex;
      align-items: center;
      ${desktopCSS(css`
        font-size: ${fontSizeDesktop};
        height: ${heightDesktop};
      `)}

      ${tabletCSS(css`
        font-size: ${fontSizeTablet};
        height: ${heightTablet};
      `)}

        ${mobileCSS(css`
        font-size: ${fontSizeMobile};
        height: ${heightMobile};
      `)}
    `
  }}
`

const StatusTitle: FunctionComponent<{ children?: ReactNode }> = ({
  children,
}) => {
  const { teaserFlex, teaserType, isInMegaModule } =
    useContext(SportsHeaderContext)

  return (
    <StyledStatusTitle
      teaserFlex={teaserFlex}
      teaserType={teaserType}
      isInMegaModule={isInMegaModule}>
      {children}
    </StyledStatusTitle>
  )
}

export default StatusTitle
